export const feeTemplateConstants = {
	GET_FEE_TEMPLATE_REQUEST: "GET_FEE_TEMPLATE_REQUEST",
	GET_FEE_TEMPLATE_SUCCESS: "GET_FEE_TEMPLATE_SUCCESS",
	GET_FEE_TEMPLATE_ERROR: "GET_FEE_TEMPLATE_ERROR",

	ADD_FEE_TEMPLATE_FORM_SUCCESS: "ADD_FEE_TEMPLATE_FORM_SUCCESS",
	ADD_FEE_TEMPLATE_FORM_ERROR: "ADD_FEE_TEMPLATE_FORM_ERROR",

	EDIT_FEE_TEMPLATE_REQUEST: "EDIT_FEE_TEMPLATE_REQUEST",
	EDIT_FEE_TEMPLATE_SUCCESS: "EDIT_FEE_TEMPLATE_SUCCESS",
	EDIT_FEE_TEMPLATE_ERROR: "EDIT_FEE_TEMPLATE_ERROR",

	PURGE_ACTIVE_FEE_TEMPLATE: "PURGE_ACTIVE_FEE_TEMPLATE",
};
